module.exports = __webpack_public_path__ + "img/17a001-12.3f6ae127.jpg";